module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step1_Image9c.565cbde5.jpg";